module.exports = __webpack_public_path__ + "static/media/ic-search-close.f0b2aea4.svg";